// 引入crypto-js包
import CryptoJS from 'crypto-js';
const AES = {
  KEY: 'NewnzBy5QWHAZH2V',
  IV: '0000000000000000'
};
/**
 * AES加密
 * @param {any} word 加密数据
 */
export function cryptoEncrypt(word) {
  let key = CryptoJS.enc.Utf8.parse(AES.KEY);
  let iv = CryptoJS.enc.Utf8.parse(AES.IV);
  let encrypted = '';
  let srcs = '';
  console.log(word, '参数');
  if (typeof word == 'string') {
    srcs = word;
  } else if (typeof word == 'object') {
    //对象格式的转成json字符串
    srcs = CryptoJS.enc.Utf8.parse(word);
  }
  encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    // padding: CryptoJS.pad.Pkcs7
    padding: CryptoJS.pad.Pkcs7
  });
  // return encrypted.ciphertext.toString();
  //使用base64
  const info = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
  console.log(info, '输出');
  return info;
}

/**
 * AES解密
 * @param {any} word 解密数据
 */
export const cryptoDecrypt = word => {
  let key = CryptoJS.enc.Utf8.parse(AES.KEY);
  let iv = CryptoJS.enc.Utf8.parse(AES.IV);
  // var encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  // var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  let decrypt = CryptoJS.AES.decrypt(word, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  decryptedStr.toString();
  console.log(JSON.parse(decryptedStr), '接口解密');
  return JSON.parse(decryptedStr);
};